import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationCityListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setCityList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationCityListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      dispatch(
        setLoading({
          key: "isOnboardCityListInProgress",
          status: true,
        }),
      );
      await axios
        .get(`${CONFIGURATION_APIS?.CITY_LIST?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IConfigurationCityListResponse>) => {
          dispatch(
            setLoading({
              key: "isOnboardCityListInProgress",
              status: false,
            }),
          );
          if (res.data.status === true) {
            dispatch(
              setCityList({
                data: res.data.data,
              }),
            );
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(
          setLoading({
            key: "isOnboardCityListInProgress",
            status: false,
          }),
        );
        const axiosError = error as AxiosError;
        if (axiosError.code === "ERR_BAD_REQUEST") {
          toast.error("Error at server while fetching city details.");
        }
        if (axiosError.response?.status === 400) {
          toast.error(axiosError.message);
        }
        if (axiosError.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return execute;
};
